import { render, staticRenderFns } from "./ListPlanos.vue?vue&type=template&id=c74453da&"
import script from "./ListPlanos.vue?vue&type=script&lang=js&"
export * from "./ListPlanos.vue?vue&type=script&lang=js&"
import style0 from "./ListPlanos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports